module.exports = __webpack_public_path__ + "static/logo_sketches_white-04a8b8efcb1de888021d80681fcdef99.svg";